var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.2266C12.4142 17.2266 12.75 17.5623 12.75 17.9766V21.4766H15C15.4142 21.4766 15.75 21.8123 15.75 22.2266C15.75 22.6408 15.4142 22.9766 15 22.9766H9C8.58579 22.9766 8.25 22.6408 8.25 22.2266C8.25 21.8123 8.58579 21.4766 9 21.4766H11.25V17.9766C11.25 17.5623 11.5858 17.2266 12 17.2266Z",
    fill: "#529CF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.97656C2 4.31971 3.34315 2.97656 5 2.97656H19C20.6569 2.97656 22 4.31971 22 5.97656V15.9766C22 17.6334 20.6569 18.9766 19 18.9766H5C3.34315 18.9766 2 17.6334 2 15.9766V5.97656Z",
    fill: "#A6C9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18.9766H19C20.6569 18.9766 22 17.6334 22 15.9766V14.9766H2V15.9766C2 17.6334 3.34315 18.9766 5 18.9766Z",
    fill: "#529CF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopImage);
export default __webpack_public_path__ + "static/media/DesktopImage.58f15a6e7df062ed4abaf649613b68b3.svg";
export { ForwardRef as ReactComponent };